module.exports = __webpack_public_path__ + "img/LUB00422.9b898f59.png";